export default __webpack_public_path__ + "static/media/MiniTape_SideA_11_Interview-Wilhelm-der-Österreicher.78805efb.mp3";